module.exports = __webpack_public_path__ + "img/prize-1.54af965e.jpg";